<template>
  <div class="flex justify-between items-center">
    <div class="w-full lg:w-45 flex flex-1 justify-center my-4 mx-4 lg:mx-0">
      <div class="w-45">
        <img src="@/assets/images/logo-novonesis-dark.svg" alt="Novonesis" class="w-32 mb-4" />
        <h2 class="font-medium text-48 text-semantic-base mb-5" :style="{ lineHeight: '56px' }">
          Proteases <br />
          Matrix Calculator
        </h2>
        <h3 class="font-semibold text-2xl text-semantic-base mb-6">Login to your account</h3>
        <p class="text-base text-semantic-base mb-4 xl:mb-8 2xl:mb-12">
          Access your account for the ProAct360™ and Ronozyme ProAct calculator.
        </p>
        <div
          v-if="errors"
          class="mb-3 bg-red-300 border border-red-400 rounded-xl p-3 md:py-3 md:px-5 font-medium text-sm text-red-400"
        >
          <template v-if="errors.email">
            <span class="icon md:mr-3.5" v-html="icons.info"></span>
            {{ errors.email[0] }}
          </template>

          <template v-if="errors.email_verified_at">
            <span class="icon md:mr-3.5" v-html="icons.info"></span>
            {{ errors.email_verified_at[0] }}
            <router-link
              :to="{ name: 'request-verification-email' }"
              class="link font-medium text-semantic-base underline hover:no-underline"
              >use this</router-link
            >
          </template>
        </div>
        <form @submit.prevent="onSubmit">
          <div class="row flex space-x-4 md:space-x-8 mb-6">
            <form-field-input
              v-model.trim="email"
              class="flex-1"
              size="medium"
              type="email"
              field-label="E-mail Address *"
              :validation-class="{ invalid: $v.email.$error, valid: !$v.email.$invalid }"
              @blur="$v.email.$touch()"
            >
              <template #helper v-if="$v.email.$error">
                <span v-if="!$v.email.required" class="invalid"> Email can't be empty </span>

                <span v-if="!$v.email.email" class="invalid"> Email isn't valid </span>

                <span v-if="errors['email'] && errors['email'].length" class="invalid"> errors['email'][0] </span>
              </template>
            </form-field-input>
          </div>

          <div class="row flex space-x-4 md:space-x-8 mb-2">
            <form-field-input
              v-model.trim="password"
              class="flex-1"
              size="medium"
              type="password"
              field-label="Password *"
              :validation-class="{ invalid: $v.password.$error, valid: !$v.password.$invalid }"
              @blur="$v.password.$touch()"
            >
              <template #helper v-if="$v.password.$error">
                <span v-if="!$v.password.required" class="invalid"> Password can't be empty </span>

                <span v-if="!$v.password.minLength" class="invalid"> min Length is 6 </span>
              </template>
            </form-field-input>
          </div>

          <div class="row flex justify-end mb-6">
            <router-link
              :to="{ name: 'reset-password' }"
              class="link font-medium text-semantic-base hover:underline text-sm"
            >
              Forgot your password?
            </router-link>
          </div>

          <div class="row">
            <button type="submit" class="btn-success w-full">Login</button>
          </div>

          <div class="row pt-4 border-t-2 border-semantic-base30 mt-4">
            <p class="m-0 text-center text-sm font-medium text-base text-semantic-base">
              Don't have an account?
              <router-link :to="{ name: 'register' }" class="link underline hover:no-underline">Sign up</router-link>
            </p>
          </div>
        </form>
      </div>
    </div>

    <div class="img flex-1 hidden md:block relative w-full img-part h-full lg:w-55">
      <img src="~@/assets/images/login-bg.jpg" alt="background image" class="h-full w-full object-cover" />
    </div>
  </div>
</template>

<script>
import FormFieldInput from '@/components/form/FormFieldInput';
import { validationMixin } from 'vuelidate';
import { mapActions, mapMutations } from 'vuex';
import { required, minLength, email } from 'vuelidate/lib/validators';

export default {
  name: 'Login',

  data: () => ({
    email: '',
    password: '',
    errors: null,
  }),

  components: {
    FormFieldInput,
  },

  mixins: [validationMixin],

  validations: {
    email: {
      required,
      email,
    },

    password: {
      required,
      minLength: minLength(6),
    },
  },

  mounted() {
    this.$store.commit('setNavigation');
    this.setLoading(false);
  },

  methods: {
    ...mapMutations({
      setLoading: 'setLoading',
    }),

    ...mapActions({
      signIn: 'auth/signIn',
    }),

    onSubmit() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }

      const formData = {
        email: this.email,
        password: this.password,
      };

      this.signIn(formData)
        .then(() => {
          this.errors = [];
          this.$router.push({ name: 'product-selection' });
        })
        .catch(err => {
          console.log(err.data);
          this.errors = err.data.errors;
          // TODO: error handling
        });

      return formData;
    },
  },
};
</script>

<style scoped></style>
